import authHeader from "./auth.header"
import constants from './constants.js'
import { apiFetch as fetch, ApiError } from './api.js'

const HOST_URL = constants.API_URL


/**
 * @param {{title, link, image?, country, publication_date, description}} favorite 
 * Every property in favorite is a string
 * @returns boolean
**/
export async function addFavorite(favorite) {
    console.log(favorite)
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/${userId}/favorites`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(favorite)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    } 
    
    // Extraire et retourner les données de la réponse
    const responseData = await response.json();
    return responseData;
}

export async function removeFavorite(favorite) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/favorites/remove`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({'user_id':userId,'link':favorite.link})
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

async function fetchCount(url) {
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return { count: 0 }
    }

    return await response.json()
}

export async function getArticleLikesCount(articleId) {
    return fetchCount(`${HOST_URL}/article/likes/${articleId}`)
}

export async function getArticleCommentsCount(articleId) {
    return fetchCount(`${HOST_URL}/article/comments/${articleId}`)
}

export async function getReviewLikesCount(reviewId) {
    return fetchCount(`${HOST_URL}/reviews/likes/${reviewId}`)
}

export async function getReviewCommentsCount(reviewId) {
    return fetchCount(`${HOST_URL}/reviews/comments/${reviewId}`)
}

/**
  * Returns a list of favorites.
  * @returns {[
  * favorite: {
    * title: string, 
    * link: string, 
    * image: string, 
    * country: string 
    * publication_date: string, 
    * description: string 
    * }
  * ]}
*/
export async function fetchFavorites() {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/users/${userId}/favorites`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    const favorites = jsonResponse.favorites
    return favorites
}

export async function fetchLatestForumFavorites(limit = 20, offset = 0) {
    const response = await fetch(`${HOST_URL}/favorites/forums/latest?limit=${limit}&offset=${offset}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }

    const jsonResponse = await response.json()
    return jsonResponse?.articles || []
}

export async function fetchIgoFavorites(igoId, targetUserId) {
    const userId = targetUserId || JSON.parse(localStorage.getItem('user')).id
    if (!userId || !igoId) return []
    const response = await fetch(`${HOST_URL}/users/${userId}/favorites/igo/${igoId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        return []
    }

    const jsonResponse = await response.json()
    if (Array.isArray(jsonResponse)) return jsonResponse
    return jsonResponse?.favorites || jsonResponse?.rows || []
}

/* Reviews */
export async function createReview(theme, presentation, selection, publishable_review, visible) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const articles = []
    for(let fav of selection){
        articles.push({
            favorite_id: fav.id,
            title: fav.title,
            link: fav.link,
            image: fav.image,
            country: fav.country,
            description: fav.description
        })
    }
    const response = await fetch(`${HOST_URL}/users/${userId}/reviews/articles`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
           'theme': theme,
           'presentation': presentation,
           'image': '', // Image ???
           'visibility_id': 1, // est-ce que ça correspond à l'ordre d'apparition
           'numero': 1, // est-ce que ça correspond à l'ordre d'apparition 
           'articles': articles,
           'sharefriends': publishable_review ? 1 : 0,
            'visible': visible   
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }
      
    return await response.json()
}

export async function deleteArticleInReview(reviewId, articleId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin) return

    const response = await fetch(`${HOST_URL}/reviews/${reviewId}/articles?id=${articleId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({'reviewId':reviewId, 'user_id': userAdmin.id})
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function deleteReview(reviewId) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/users/${userId}/reviews/${reviewId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({'userId':userId, 'reviewId':reviewId})
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function getReviewById(reviewId) { 
    const response = await fetch(`${HOST_URL}/reviews/${reviewId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
    // const favorites = jsonResponse.favorites
    // return favorites
}



export async function getPublishableReviewByUserId(userId) { 
    const response = await fetch(`${HOST_URL}/users/${userId}/publishable-review`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
    // const favorites = jsonResponse.favorites
    // return favorites
}

export async function getFriendsReviews(userId, firstElement, lastElement, query) {
    let response
    if (query !== '') {
        response = await fetch(`${HOST_URL}/reviews/friends/${userId}/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(`${HOST_URL}/reviews/friends/${userId}/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function updateReview(review) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/reviews/${review.id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'theme': review.theme,
            'presentation': review.presentation, 
            'sharefriends': review.sharefriends,
            'visible': review.visible ? parseInt(review.visible) : 0,
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function removeArticle(articleId) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/articles/${articleId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function addArticlesToReview(articles, reviewId) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/reviews/${reviewId}/articles`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ sharingUserId:userId, articles:articles })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function getArticleById(articleId) {
    const response = await fetch(`${HOST_URL}/article/${articleId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getArticles(firstElement, lastElement, query, visible, language) {
    let response
    if (query !== '') {
        response = await fetch(`${HOST_URL}/articles/${language}/${firstElement}/${lastElement}/${query}/${visible}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(`${HOST_URL}/articles/${language}/${firstElement}/${lastElement}/${visible}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getArticlesToModerate(firstElement, lastElement, query, language) {
    let response
    if (query !== '') {
        response = await fetch(`${HOST_URL}/articles/moderated/${language}/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(`${HOST_URL}/articles/moderated/${language}/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getReviewsToModerate(firstElement, lastElement, query) {
    let response
    if (query !== '') {
        response = await fetch(`${HOST_URL}/reviews/moderated/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(`${HOST_URL}/reviews/moderated/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

async function feedModerationRequest(path, method = 'GET', body) {
    const response = await fetch(`${HOST_URL}${path}`, {
        method,
        headers: {
            'Accept': 'application/json',
            ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
            ...authHeader()
        },
        body: body === undefined ? undefined : JSON.stringify(body)
    })

    if (!response.ok) {
        let message = `La requête a échoué (${response.status}).`
        try {
            const payload = await response.json()
            message = payload?.message || payload?.error || message
        } catch (error) {
            // Certaines réponses d'erreur ne contiennent pas de JSON.
        }
        throw new ApiError(response.status, message)
    }

    if (response.status === 204) return true
    return response.json()
}

export async function getFeedModerationReports(firstElement, lastElement, query = '') {
    const search = query.trim()
    const path = `/feed/moderation/reports/${firstElement}/${lastElement}${search ? `/${encodeURIComponent(search)}` : ''}`
    return feedModerationRequest(path)
}

export const dismissFeedModerationReport = (feedId) =>
    feedModerationRequest('/feed/moderation/dismiss', 'POST', { feed_id: feedId })

export const deleteFeedModerationReport = (feedId, comment = '') =>
    feedModerationRequest('/feed/moderation/delete', 'POST', {
        feed_id: feedId,
        ...(comment ? { comment } : {})
    })

export async function updateModerationArticle(articleId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin) return
    const response = await fetch(`${HOST_URL}/article/update/moderation`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({'article_id':articleId})
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function updateModerationReview(reviewId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin) return
    const response = await fetch(`${HOST_URL}/reviews/update/moderation`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({'review_id':reviewId})
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function getArticlesByAuthorId(userId, firstElement, lastElement, visible, query) {
    const visibility = Number(visible ?? 1)
    const baseUrl = `${HOST_URL}/article/user/${userId}/${firstElement}/${lastElement}/visible/${visibility}`
    const response = await fetch(`${baseUrl}${query ? `/${query}` : ''}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getVisibleArticleFromUserId(userId) {
    const response = await fetch(`${HOST_URL}/article/visible/${userId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
    
}

export async function getFriendsArticles(userId, firstElement, lastElement, query) {
    let response
    if (query !== '') {
        response = await fetch(`${HOST_URL}/article/friends/${userId}/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(`${HOST_URL}/article/friends/${userId}/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function createArticle(user_id, title, description, language, visible, rotation) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/article/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'user_id' : user_id,
            'title': title,
            'description': description,
            'language': language,
            'visible': visible,
            'rotation_featured_image': rotation
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }
      
    return await response.json()
}

export async function updateArticle(article) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/article/update/${article.id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'user_id': article.user_id,
            'title': article.title,
            'description': article.description, 
            'language': article.language,
            'visible': article.visible ? 1 : 0,
            'remove_image': article.remove_image ? 1 : 0,
            'rotation_featured_image': article.rotation_featured_image
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function removeOwnArticle(article) {
    console.log(article)
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/article/delete`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(article.message === "" ? {'articleId':article.id, 'user_id':userId} : {'articleId':article.id, 'user_id':userId, 'message': article.message})
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function getStatusVisibleArticle(articleId) {
    const response = await fetch(`${HOST_URL}/article/status/${articleId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function uploadFeaturedImage(articleId, image) {
    const formData = new FormData();
    formData.append('image', image)
    console.log(formData)
    const response = await fetch(`${HOST_URL}/article/${articleId}/featured_image`, {
        method: 'POST',
        headers: {
            ...authHeader()
        },
        body: formData
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function getFeaturedImage(articleId) {
    const response = await fetch(`${HOST_URL}/article/${articleId}/featured_image`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return await response.blob()
}

export async function getFeedArticles(userId, firstElement, lastElement, visible, query) {
    const response = await fetch(`${HOST_URL}/article/feed/${userId}/${firstElement}/${lastElement}/${visible}${query ? "/"+query : ""}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getFeedReviews(userId, firstElement, lastElement, visible, query) {
    const response = await fetch(`${HOST_URL}/reviews/feed/${userId}/${firstElement}/${lastElement}/${visible}${query ? "/"+query : ""}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getUserReviewsPaginated(userId, firstElement, lastElement, visible, query) {
    const visibility = Number(visible ?? 1)
    const baseUrl = `${HOST_URL}/reviews/user/${userId}/${firstElement}/${lastElement}/visible/${visibility}`
    const response = await fetch(`${baseUrl}${query ? `/${query}` : ''}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getAIReviewThemeAndPresentation(language, styleReview, articlesLinks, userId) {
    const response = await fetch(`${HOST_URL}/ai/title-and-presentation-review`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'language': language,
            'style_review': styleReview,
            'articlesLinks': articlesLinks,
            'userId': userId
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getAIReviewThemeAndPresentationByUser(language, prompt, articleLinks, userId) {
    const response = await fetch(`${HOST_URL}/ai/title-and-presentation-review-by-user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'language': language,
            'prompt': prompt,
            'articlesLinks': articleLinks,
            'userId': userId
        })
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }
    const jsonResponse = await response.json()
    return jsonResponse
}

function stringifyExpertValue(value) {
    if (Array.isArray(value)) return value.map(stringifyExpertValue).join('\n\n')
    if (value && typeof value === 'object') {
        return Object.values(value).map(stringifyExpertValue).join('\n\n')
    }
    return value == null ? '' : String(value)
}

// Échappe les retours à la ligne / tabulations bruts à l'intérieur des chaînes JSON
function escapeControlCharsInJsonStrings(text) {
    let result = ''
    let inString = false
    let escaped = false
    for (const char of text) {
        if (inString) {
            if (escaped) {
                escaped = false
            } else if (char === '\\') {
                escaped = true
            } else if (char === '"') {
                inString = false
            } else if (char === '\n') {
                result += '\\n'
                continue
            } else if (char === '\r') {
                continue
            } else if (char === '\t') {
                result += '\\t'
                continue
            }
        } else if (char === '"') {
            inString = true
        }
        result += char
    }
    return result
}

function tryParseJson(text) {
    const candidates = [text]
    const start = text.indexOf('{')
    const end = text.lastIndexOf('}')
    if (start !== -1 && end > start) candidates.push(text.slice(start, end + 1))
    for (const candidate of candidates) {
        for (const attempt of [candidate, escapeControlCharsInJsonStrings(candidate)]) {
            try {
                return JSON.parse(attempt)
            } catch (error) {
                // essai suivant
            }
        }
    }
    return undefined
}

function extractExpertFieldsFromText(text) {
    const themeMatch = text.match(/"theme"\s*:\s*"((?:[^"\\]|\\.)*)"/)
    const presentationMatch = text.match(/"presentation"\s*:\s*("(?:[^"\\]|\\[\s\S])*"|\[[\s\S]*\])/)
    if (!themeMatch && !presentationMatch) return null
    const decode = (raw) => {
        try {
            return JSON.parse(escapeControlCharsInJsonStrings(raw))
        } catch (error) {
            return raw.replace(/^"|"$/g, '').replace(/\\n/g, '\n').replace(/\\"/g, '"')
        }
    }
    return {
        theme: themeMatch ? String(decode(`"${themeMatch[1]}"`)) : '',
        presentation: presentationMatch ? stringifyExpertValue(decode(presentationMatch[1])) : ''
    }
}

function parseExpertReview(rawText) {
    const text = (rawText || '').trim()
    const unfenced = text.replace(/^```(?:json)?\s*/i, '').replace(/\s*```$/, '').trim()

    let parsed = tryParseJson(unfenced)
    // Réponse double-encodée : une chaîne JSON qui contient elle-même du JSON
    if (typeof parsed === 'string') {
        const inner = tryParseJson(parsed.trim())
        parsed = inner !== undefined ? inner : parsed
    }

    if (typeof parsed === 'string') return { theme: '', presentation: parsed }
    if (parsed && typeof parsed === 'object') {
        return {
            theme: stringifyExpertValue(parsed.theme),
            presentation: stringifyExpertValue(parsed.presentation)
        }
    }

    const extracted = extractExpertFieldsFromText(unfenced)
    if (extracted) return extracted
    return { theme: '', presentation: text }
}

/**
 * Dernières préférences utilisées pour la revue de presse experte.
 * Renvoie null s'il n'y en a pas ou en cas d'erreur (le formulaire garde alors ses valeurs par défaut).
 */
export async function fetchExpertReviewPreferences() {
    try {
        const response = await fetch(`${HOST_URL}/ai/title-and-presentation-review-expert/preferences`, {
            method: 'GET',
            headers: { 'Accept': 'application/json', ...authHeader() }
        })
        if (!response.ok || response.status === 204) return null
        const data = await response.json()
        return data && typeof data === 'object' ? (data.preferences || data) : null
    } catch (error) {
        return null
    }
}

/**
 * Revue de presse experte (sections A à G).
 * @param {number|string} userId
 * @param {string[]} articlesLinks au moins une URL
 * @param {object} options payload construit par le composant (voir buildExpertPayload dans articlesfav.js)
 * @returns {Promise<{theme: string, presentation: string}>}
 */
export async function getAIReviewThemeAndPresentationExpert(userId, articlesLinks, options = {}) {
    const body = { userId, articlesLinks, ...options }
    // apiFetch gère déjà 401 (redirection login), 403, 422 et 429
    const response = await fetch(`${HOST_URL}/ai/title-and-presentation-review-expert`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain',
            ...authHeader()
        },
        body: JSON.stringify(body)
    })

    if (!response.ok) {
        let payload = null
        try {
            payload = await response.json()
        } catch (error) {
            payload = null
        }
        if (response.status === 400) {
            throw new ApiError(400, payload?.message || 'La requete envoyee est invalide.')
        }
        throw new ApiError(response.status, 'Le service IA est temporairement indisponible.')
    }

    return parseExpertReview(await response.text())
}

const USER_EXPERT_OPTIONAL_FIELDS = ['centralQuestion', 'priorityAudience', 'geographicInstitutionalScope', 'purpose', 'timeHorizon', 'desiredLength']

/**
 * Analyse stratégique experte (note stratégique), texte brut.
 * @param {number|string} userId
 * @param {string[]} articlesLinks au moins une URL
 * @param {{centralQuestion?, priorityAudience?, geographicInstitutionalScope?, purpose?, timeHorizon?, desiredLength?, supplementarySources?: 'verification'|'provided-only'}} options
 * @returns {Promise<{theme: string, presentation: string}>}
 */
export async function getAIReviewThemeAndPresentationByUserExpert(userId, articlesLinks, options = {}) {
    const body = { userId, articlesLinks }
    for (const field of USER_EXPERT_OPTIONAL_FIELDS) {
        const value = typeof options[field] === 'string' ? options[field].trim() : options[field]
        if (value) body[field] = value
    }
    if (options.supplementarySources === 'verification' || options.supplementarySources === 'provided-only') {
        body.supplementarySources = options.supplementarySources
    }

    const response = await fetch(`${HOST_URL}/ai/title-and-presentation-review-by-user-expert`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain',
            ...authHeader()
        },
        body: JSON.stringify(body)
    })

    if (!response.ok) {
        let payload = null
        try {
            payload = await response.json()
        } catch (error) {
            payload = null
        }
        if (response.status === 400) {
            throw new ApiError(400, payload?.message || 'La requete envoyee est invalide.')
        }
        throw new ApiError(response.status, 'Le service IA est temporairement indisponible.')
    }

    return parseExpertReview(await response.text())
}

export async function getArticleContentFromScreenshot(articleLink) {
    const response = await fetch(`${HOST_URL}/ai/article-content-from-screenshot`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({"articleLink": articleLink, "test": false})
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return ""
    }

    const textResponse = await response.json()
    return textResponse
}

export async function getFactChecking(articleLink) {
    const response = await fetch(`${HOST_URL}/article/factcheck`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'link': articleLink,
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    if (response.status === 204) {
        return
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getArticleSummary(articleLink) {
    const response = await fetch(`${HOST_URL}/article/summary`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'link': articleLink,
        })
    })

    if (response.status === 204) {
        return null
    }

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function addArticleSummary(articleLink) {
    const response = await fetch(`${HOST_URL}/article/summary/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'link': articleLink,
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return await response.json()
    }

    return await response.json()
}

export async function addFactChecking(articleLink) {
    const response = await fetch(`${HOST_URL}/article/factcheck/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'link': articleLink,
        })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return await response.json()
    }

    return await response.json()
}

export async function addMultiFactChecking(articles) {
    const response = await fetch(`${HOST_URL}/article/factcheck/add-multi`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(articles)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return await response.json()
    }

    return await response.json()
}

export async function isAiActivated() {
    const response = await fetch(`${HOST_URL}/options/ai_activation`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getOriginArticleFromLink(articleLink) {
    const response = await fetch(`${HOST_URL}/country/favorite/origin`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({
            'link': articleLink,
        })
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }
    const jsonResponse = await response.json()
    return jsonResponse
}
